module.exports = __webpack_public_path__ + "static/media/hotSpot_premium_hover.704f6294.png";